export default Object.freeze({
  Ftp: 1,
  Sftp: 2,
  Ftps: 3,
});
